export default {
      id: "pentagonal-usage",
      viewBox: "0 0 30 29",
      url: __webpack_public_path__ + "icons.svg#pentagonal",
      toString: function () {
        return this.url;
      }
    }